// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".required-label span {\r\n    color: #f44336;\r\n  }", "",{"version":3,"sources":["webpack://src/stories/hook-controls/input-autocomplete/index.css"],"names":[],"mappings":"AAAA;IACI,cAAc;EAChB","sourcesContent":[".required-label span {\r\n    color: #f44336;\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
